"use client";

type PublishUpdateInfoProps = {
  publishedOn: string;
  updatedOn: string;
  showPublished?: boolean;
  /** ISO 8601 datetime + "YYYY-MM-DD HH:mm" title for a semantic <time>
   *  element (Google SERP reads these), from getTimeAgoMeta(). Optional —
   *  falls back to a plain <span> when the caller doesn't have a raw
   *  timestamp to derive them from. */
  publishedIso?: string;
  publishedTitle?: string;
  updatedIso?: string;
  updatedTitle?: string;
};
export default function publishon({
  publishedOn,
  updatedOn,
  showPublished = true,
  publishedIso,
  publishedTitle,
  updatedIso,
  updatedTitle
}: PublishUpdateInfoProps) {
  return <div className="flex items-center gap-6">
      {/* Published */}
      {showPublished && <div className="flex items-center gap-1">
          <span className="text-12-tamil-300 text-1B1B1B">Published On :</span>
          {publishedIso ? <time className="text-12-tamil-500 text-1B1B1B" dateTime={publishedIso} title={publishedTitle}>
              {publishedOn}
            </time> : <span className="text-12-tamil-500 text-1B1B1B">{publishedOn}</span>}
        </div>}

      {/* Updated */}
      <div className="flex items-center gap-1">
        <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
        {updatedIso ? <time className="text-12-tamil-500 text-1B1B1B" dateTime={updatedIso} title={updatedTitle}>
            {updatedOn}
          </time> : <span className="text-12-tamil-500 text-1B1B1B">{updatedOn}</span>}
      </div>
    </div>;
}